import DuckEntity from './DuckEntity';

const entity = new DuckEntity('combinedFunnelReport', {
  apiPath: 'reporting/combined_funnel_report',
  jsonRoot: 'combined_funnel_report',
  jsonIndexRoot: 'combined_funnel_report'
});
export default entity.reducer;
export { entity };
